import { useEffect, useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Reservation from './components/Reservation';
import Contact from './components/Contact';
import Footer from './components/Footer';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const schemaData = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Hotel',
      '@id': `${SITE_URL}/#hotel`,
      name: '영빈호텔',
      alternateName: 'Youngbin Hotel',
      url: SITE_URL,
      telephone: '+82-2-2277-1141',
      email: 'youngbinhotel@hotmail.com',
      description: '서울 동대문 영빈호텔. 동대문 국제패션타운 인접, 지하철 2·3·4·5호선 연결, 사우나·무료와이파이·24시간 컨시어지 제공.',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '종로 266',
        addressLocality: '종로구',
        addressRegion: '서울특별시',
        postalCode: '03141',
        addressCountry: 'KR',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: 37.5636,
        longitude: 127.0086,
      },
      checkinTime: '15:00',
      checkoutTime: '12:00',
      amenityFeature: [
        { '@type': 'LocationFeatureSpecification', name: '무료 와이파이', value: true },
        { '@type': 'LocationFeatureSpecification', name: '사우나', value: true },
        { '@type': 'LocationFeatureSpecification', name: '24시간 컨시어지', value: true },
        { '@type': 'LocationFeatureSpecification', name: '주차장', value: true },
      ],
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
          opens: '00:00',
          closes: '23:59',
        },
      ],
      priceRange: '₩₩',
      image: `${SITE_URL}/og-image.jpg`,
      sameAs: ['http://www.youngbinhotel.com'],
    },
    {
      '@type': 'WebSite',
      '@id': `${SITE_URL}/#website`,
      url: SITE_URL,
      name: '영빈호텔 | YOUNGBIN HOTEL',
      inLanguage: 'ko-KR',
    },
  ],
};

const HomePage = () => {
  const [showTopBtn, setShowTopBtn] = useState(false);

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-home';
    script.textContent = JSON.stringify(schemaData);
    document.head.appendChild(script);
    return () => {
      const el = document.getElementById('schema-home');
      if (el) el.remove();
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setShowTopBtn(window.scrollY > 400);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <main className="min-h-screen">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Reservation />
      <Contact />
      <Footer />

      {/* 탑버튼 */}
      <button
        onClick={scrollToTop}
        className={`fixed bottom-8 right-8 z-50 w-12 h-12 flex items-center justify-center bg-amber-800 text-white rounded-full shadow-md transition-all duration-300 cursor-pointer whitespace-nowrap hover:bg-amber-700 ${
          showTopBtn ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
        }`}
        aria-label="맨 위로 이동"
      >
        <i className="ri-arrow-up-line text-xl"></i>
      </button>
    </main>
  );
};

export default HomePage;
